import push from 'src/utils/notice/push';
import {
  subscribe, isSubscribe, unSubscribe, disconnect,
} from 'src/utils/notice/subscribe';

export default {
  subscribe,
  push,
  isSubscribe,
  unSubscribe,
  disconnect,
};
